import { useMemo, useState } from "react";
import { ProjectCard } from "./ProjectCard";
import { PROJECT_CATEGORIES } from "../../data/portfolio";

const pill = (on) => `rounded-full px-4 py-2 text-[14px] font-semibold transition-colors ${on ? "bg-ink text-white" : "bg-white text-slate-600 ring-1 ring-slate-200 hover:text-ink hover:ring-slate-300"}`;

export const ProjectsGrid = ({ items }) => {
  const [cat, setCat] = useState("");
  const [place, setPlace] = useState("");
  const cats = PROJECT_CATEGORIES.filter((c) => items.some((p) => p.categories?.includes(c.id)));
  const places = useMemo(() => [...new Set(items.map((p) => p.plaats).filter(Boolean))].sort(), [items]);
  const shown = items.filter((p) => (!cat || p.categories?.includes(cat)) && (!place || p.plaats === place));
  return (
    <section aria-labelledby="projecten-lijst" className="section" data-testid="projects-section">
      <div className="container-tight">
        <h2 id="projecten-lijst" className="h2">Uitgevoerde projecten</h2>
        <div className="mt-6 flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between" data-testid="projects-filter-bar">
          <div className="flex flex-wrap gap-2" role="group" aria-label="Filter op product">
            <button type="button" className={pill(!cat)} onClick={() => setCat("")} aria-pressed={!cat} data-testid="projects-filter-all">Alles</button>
            {cats.map((c) => (
              <button key={c.id} type="button" className={pill(cat === c.id)} onClick={() => setCat(c.id)} aria-pressed={cat === c.id} data-testid={`projects-filter-${c.id}`}>{c.label}</button>
            ))}
          </div>
          {places.length > 1 && (
            <label className="flex items-center gap-2 text-[14px] text-slate-600">
              Plaats
              <select value={place} onChange={(e) => setPlace(e.target.value)} className="h-10 rounded-xl border border-slate-300 bg-white px-3 text-[14px] text-ink" data-testid="projects-filter-place">
                <option value="">Alle plaatsen</option>
                {places.map((pl) => <option key={pl} value={pl}>{pl}</option>)}
              </select>
            </label>
          )}
        </div>
        <p className="mt-4 text-[14px] text-slate-500" data-testid="projects-count">{shown.length} {shown.length === 1 ? "project" : "projecten"}</p>
        <ul className="mt-6 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">{shown.map((p) => <ProjectCard key={p.id} p={p} />)}</ul>
      </div>
    </section>
  );
};
